import http from "@/http/aisea/axios";
const resource = "/enterprises/crews";

export default {
  recordBooks(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/timesheet/record_books`, {
      ...payload,
    });
  },
  // ダウンロード
  export(enterpriseCrewId, payload, responseType = "blob") {
    return http.get(
      `${resource}/${enterpriseCrewId}/timesheet/record_books/export`,
      {
        ...payload,
        responseType,
      }
    );
  },

  exportByDateRange(enterpriseCrewId, payload, responseType = "blob") {
    return http.get(
      `${resource}/${enterpriseCrewId}/timesheet/record_books/export_by_date_range`,
      {
        ...payload,
        responseType,
      }
    );
  },
};
